import {SortDown, SortUp} from "react-bootstrap-icons";
import React from "react";

type SortDirectionProps = {
    isActive: boolean;
    order: string;
};

const SortDirection : React.FC<SortDirectionProps> =  ({ isActive, order }: SortDirectionProps) => {

    let content;

    if (isActive) {
        if (order !== 'asc')
            content = <SortUp />;
        else
            content = <SortDown />;
    }
    return (
        <span className="mx-1">{content}</span>
    )
}
export default SortDirection;